export const treoBreakpoints = {
  xs: '(min-width:  0) and (max-width:  599px)',
  sm: '(min-width:  600px) and (max-width:  959px)',
  md: '(min-width:  960px) and (max-width:  1279px)',
  lg: '(min-width:  1280px) and (max-width:  1439px)',
  xl: '(min-width:  1440px)',
  'lt-md': '(max-width:  959px)',
  'lt-lg': '(max-width:  1279px)',
  'lt-xl': '(max-width:  1439px)',
  'gt-xs': '(min-width:  600px)',
  'gt-sm': '(min-width:  960px)',
  'gt-md': '(min-width:  1280px)',
};
